





































































import Vue from 'vue';
/* globals process */
import { required } from 'vuelidate/lib/validators';
import { emailAddress } from '@/validations';

import { FormValidation } from '@/mixins';

import { api, ADDRESS_VALIDATION_API_SUB_URLS } from '@/api';

import { EventBus } from '@/event-bus';
import { ExtendMixins } from '@/services';

interface Data {
  confirmingEmail: boolean;
  emailModel: string;
  isLoading: boolean;
  showValidateEmailErrorMessage: boolean;
  validateEmailErrorHeaderTitle: string[];
  validateEmailErrorHeaderText: string[];
  validateEmailErrorEmailMessage: string[];
  validateEmailErrorFormMessage: string[];
}

export default ExtendMixins(
  FormValidation,
).extend({
  name: 'ValidateEmail',
  props: {
    email: {
      type: String,
      required: true,
    },
    validateEmailIsLoading: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    emailModel: {
      required,
      emailAddress,
    },
  },
  watch: {
    validateEmailIsLoading(val) {
      if (val) {
        this.emailModel = this.email;
        this.validateEmail(this.emailModel);
      }
    },
  },
  data(): Data {
    return {
      confirmingEmail: false,
      emailModel: '',
      isLoading: false,
      showValidateEmailErrorMessage: false,
      validateEmailErrorHeaderTitle: [
        'validate-email_error_default_header-title',
      ],
      validateEmailErrorHeaderText: [
        'validate-email_error_default_header-text',
      ],
      validateEmailErrorEmailMessage: [
        'validate-email_error_default_email-message',
      ],
      validateEmailErrorFormMessage: [
        'validate-email_error_default_form-message',
      ],
    };
  },
  beforeMount() {
    this.showErrorModel.emailModel = false;
  },
  methods: {
    cancelEmailValidation(): void {
      this.showValidateEmailErrorMessage = false;
      this.$emit('emailValidationCancel');
    },
    validateEmail(model): void {
      this.isLoading = true;

      if (this.confirmingEmail) {
        this.showValidateEmailErrorMessage = false;
        this.$emit('emailValidationSuccess', this.emailModel);

        return;
      }

      api
        .post(
          `${ADDRESS_VALIDATION_API_SUB_URLS.emails}`,
          {
            address: this.emailModel,
          },
          {
            headers: {
              'x-api-key': process.env.VUE_APP_TOKEN_API_KEY,
            },
          },
        )
        .then((response) => {
          const errorStatusCodeString = response.data.status;

          if (errorStatusCodeString === 'verified') {
            this.showValidateEmailErrorMessage = false;
            this.$emit('emailValidationSuccess', this.emailModel);
          } else {
            this.confirmingEmail = true;

            this.validateEmailErrorHeaderTitle = [
              `validate-email_error_${errorStatusCodeString}_header-title`,
            ];
            this.validateEmailErrorHeaderText = [
              `validate-email_error_${errorStatusCodeString}_header-text`,
            ];
            this.validateEmailErrorEmailMessage = [
              `validate-email_error_${errorStatusCodeString}_email-message`,
            ];
            this.validateEmailErrorFormMessage = [
              `validate-email_error_${errorStatusCodeString}_form-message`,
            ];

            this.showValidateEmailErrorMessage = true;
            this.isLoading = false;
            setTimeout(() => {
              (this.$refs.emailField as any).focus();
            }, 0);
            this.$emit('emailValidationError');
          }
        })
        .catch(() => {
          this.isLoading = false;
          EventBus.$emit('openModal', 'Error', {
            message: 'global_connection-error',
            action: {
              label: 'global_dismiss',
              performAction: () => {
                this.cancelEmailValidation();
              },
            },
            hideCancel: true,
          });
        });
    },
  },
  computed: {
    emailErrors(): string[] {
      const formField = 'emailModel';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'validate-email_form-error_email_required',
            'global_form-error_email_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'validate-email_form-error_email_invalid-format',
            'global_form-error_default_invalid-format',
          ],
          'emailAddress',
        ),
      ]);
    },
  },

});
